/* DHPS spec-strip: eigen keuzelijst in huisstijl bovenop de native <select>.
   De <select> blijft (verborgen) de bron van waarheid: dhps-set-cart.js leest
   select.value, dhps-sami-indoor-price.js past de optieteksten aan en de
   vermogen/kleur-selects navigeren via hun onchange. Deze laag toont alleen
   een gestylede knop + lijst en zet bij een keuze select.value + 'change'.
   30-09-2026: focus() met preventScroll, anders scrollt de browser op mobiel
   de hele pagina horizontaal mee naar de knop. */
(() => {
  const CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  let openDd = null;

  function enhance(select) {
    if (select.dataset.dhpsEnhanced === 'true') return;
    select.dataset.dhpsEnhanced = 'true';

    const card = select.closest('.dhps-spec-card');
    if (card) card.classList.add('dhps-dd-card');

    const wrap = document.createElement('div');
    wrap.className = 'dhps-dd';
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    select.classList.add('dhps-dd__native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dhps-dd__button';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="dhps-dd__text"></span><span class="dhps-dd__chev">' + CHEV + '</span>';

    const list = document.createElement('ul');
    list.className = 'dhps-dd__list';
    list.setAttribute('role', 'listbox');
    list.id = (select.id || 'dhps-dd-' + Math.random().toString(36).slice(2)) + '-list';
    list.hidden = true;
    btn.setAttribute('aria-controls', list.id);
    const aria = select.getAttribute('aria-label');
    if (aria) { btn.setAttribute('aria-label', aria); list.setAttribute('aria-label', aria); }

    wrap.appendChild(btn);
    wrap.appendChild(list);

    let active = -1;

    function render() {
      const sel = select.options[select.selectedIndex];
      const text = btn.querySelector('.dhps-dd__text');
      text.textContent = sel ? sel.textContent.trim() : '';
      text.classList.toggle('is-placeholder', !sel || sel.value === '');
      list.innerHTML = '';
      Array.from(select.options).forEach((o, i) => {
        const li = document.createElement('li');
        li.className = 'dhps-dd__option';
        li.setAttribute('role', 'option');
        li.dataset.index = String(i);
        li.textContent = o.textContent.trim();
        if (o.value === '') li.classList.add('is-placeholder');
        if (i === select.selectedIndex) li.setAttribute('aria-selected', 'true');
        if (o.disabled) li.setAttribute('aria-disabled', 'true');
        list.appendChild(li);
      });
      if (!list.hidden) setActive(active);
    }

    function items() { return Array.from(list.querySelectorAll('.dhps-dd__option')); }

    function setActive(i) {
      const all = items();
      all.forEach((li) => li.classList.remove('is-active'));
      if (i < 0 || i >= all.length) { active = -1; return; }
      active = i;
      all[i].classList.add('is-active');
      all[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    function move(step) {
      const all = items();
      let i = active;
      for (let n = 0; n < all.length; n++) {
        i = (i + step + all.length) % all.length;
        if (all[i].getAttribute('aria-disabled') !== 'true') { setActive(i); return; }
      }
    }

    function open() {
      if (openDd && openDd !== api) openDd.close();
      list.hidden = false;
      list.classList.remove('is-right');
      btn.setAttribute('aria-expanded', 'true');
      if (card) card.classList.add('is-open');
      const rect = list.getBoundingClientRect();
      if (rect.right > window.innerWidth - 12) list.classList.add('is-right');
      setActive(select.selectedIndex);
      openDd = api;
    }

    function close() {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (card) card.classList.remove('is-open');
      if (openDd === api) openDd = null;
    }

    function choose(i) {
      const o = select.options[i];
      if (!o || o.disabled) return;
      close();
      btn.focus({ preventScroll: true });
      if (i === select.selectedIndex) return;
      select.selectedIndex = i;
      render();
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const api = { close, wrap };

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      list.hidden ? open() : close();
    });

    btn.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          list.hidden ? open() : move(1);
          break;
        case 'ArrowUp':
          e.preventDefault();
          list.hidden ? open() : move(-1);
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (list.hidden) open(); else if (active >= 0) choose(active);
          break;
        case 'Escape':
          if (!list.hidden) { e.preventDefault(); close(); }
          break;
        case 'Tab':
          close();
          break;
      }
    });

    list.addEventListener('mousedown', (e) => e.preventDefault());
    list.addEventListener('click', (e) => {
      const li = e.target.closest('.dhps-dd__option');
      if (li) choose(Number(li.dataset.index));
    });
    list.addEventListener('mousemove', (e) => {
      const li = e.target.closest('.dhps-dd__option');
      if (li && li.getAttribute('aria-disabled') !== 'true') setActive(Number(li.dataset.index));
    });

    if (card) {
      const label = select.id ? card.querySelector('label[for="' + select.id + '"]') : null;
      if (label) label.addEventListener('click', (e) => { e.preventDefault(); btn.focus({ preventScroll: true }); list.hidden ? open() : close(); });
      card.addEventListener('click', (e) => {
        if (e.target.closest('.dhps-dd__button, .dhps-dd__list, label')) return;
        btn.focus({ preventScroll: true });
        list.hidden ? open() : close();
      });
    }

    select.addEventListener('change', render);
    new MutationObserver(render).observe(select, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'selected'] });

    render();
  }

  document.addEventListener('click', (e) => {
    if (openDd && !openDd.wrap.closest('.dhps-spec-card').contains(e.target)) openDd.close();
  });

  function init() {
    document.querySelectorAll('.dhps-spec-strip select').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
